import SearchQueryAdd from './SearchQueryAdd';
import SearchQueryEdit from './SearchQueryEdit';

export default {
    Add: SearchQueryAdd,
    Edit: SearchQueryEdit
};
